<div class="container text-center">
  <h1 class="work-title">Weddings</h1>
</div>

<div class="container-fluid">
  <a *ngFor="let work of works" [href]="'work/' + work.url">
    <img [src]="work.thumbImg" class="img-fluid homepage-thumb" alt="Responsive image">
  </a>
</div>
